'use client'
import { disableBodyScroll, enableBodyScroll } from '@/utils/dom'
import { useCallback, useState } from 'react'

export function usePopup(value = false, needDisableScroll = false) {
  const [isVisible, setIsVisible] = useState<boolean>(() => {
    if (value === true && needDisableScroll) {
      disableBodyScroll()
    }
    return value
  })

  const show = useCallback(() => {
    setIsVisible(true)
    if (needDisableScroll) {
      disableBodyScroll()
    }
  }, [needDisableScroll])

  const hide = useCallback(() => {
    setIsVisible(false)
    if (needDisableScroll) {
      enableBodyScroll()
    }
  }, [needDisableScroll])

  const setVisible = useCallback(
    (value: boolean) => {
      setIsVisible(value)

      if (needDisableScroll) {
        if (value) {
          disableBodyScroll()
        } else {
          enableBodyScroll()
        }
      }
    },
    [needDisableScroll]
  )

  const toggle = useCallback(() => {
    if (isVisible) {
      hide()
    } else {
      show()
    }
  }, [isVisible, show, hide])

  return {
    isVisible,
    setVisible,
    hide,
    show,
    toggle,
  }
}
